module.exports = __webpack_public_path__ + "assets/img/main-about.1a7e674a.png";